import { WalletConnectionErrorPayload, WalletIdentity } from './wallet-connector.model';

export enum WalletIdentityStatus {
  Connected = 'connected',
  Connecting = 'connecting',
  Disconnected = 'disconnected',
  Error = 'error',
  Idle = 'idle',
  Rejected = 'rejected',
  Unavailable = 'unavailable',
  UnsupportedChain = 'unsupported-chain',
}

export interface WalletIdentityState {
  error: WalletConnectionErrorPayload | null;
  identity: WalletIdentity | null;
  status: WalletIdentityStatus;
  walletDataRefreshRevision: number;
}
